import React from 'react';
import './AntiVirus.css';

const PassList = () => {
  /* Change this if you want to change any of your "top VPN" rankings items */
  const topPassMans = [
    {
      tName: ' SurfShark AntiVirus',
      tRating: '9.7/10',
      tUrl: 'https://surfshark.com/antivirus',
      tImg: 'https://upload.wikimedia.org/wikipedia/en/d/d2/Surfshark_Antivirus_logo.png',
      tDescription: "Good bundle prices with VPN and antivirus for all devices, perfect for a home with many users, and a safe VPN to bundle in. Light on the devices doesn't take many resources.",
    },
    {
      tName: ' Malwarebytes',
      tRating: '9.5/10',
      tUrl: 'https://www.malwarebytes.com/',
      tImg: 'https://upload.wikimedia.org/wikipedia/commons/d/db/Malwarebytes_logo_stacked_PMS2728.png',
      tDescription: "Known and trusted antivirus; however, it comes with a premium Price and supports only a limited number of devices. It's also light and doesn't take up many resources.",
    },
    {
      tName: ' Bitdefender',
      tRating: '9.0/10',
      tUrl: 'https://www.bitdefender.com/en-us/consumer/total-security',
      tImg: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-3PHHcwb8yah1KRAt9wv0prlOJ3cF8q4BCw&s',
      tDescription: 'Best free and open source password manager',
    },
    {
      tName: ' Kaspersky',
      tRating: '8.8/10',
      tUrl: 'https://www.kaspersky.com/home-security',
      tImg: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlDgqdixdc1RmP_QxmlZQXknqO6j6MYU2qCg&s',
      tDescription: 'Robust anti-virus, known for decades, good, and light on the device. Has some questionable history. Currently not as recommended.',
    },
    {
      tName: ' Avast',
      tRating: '8.7/10',
      tUrl: 'https://www.avast.com/en-us/index#pc',
      tImg: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJXl0JV_GZpvNt7jEGexcQKzIhvx_SIhDq2A&s',
      tDescription: 'Has many pop-ups, runs heavy on the device, and has reasonable pricing. Known in the anti-virus community. Has an okay detection rate.',
    }
  ];

  return (
    <div className="tier-list">
      <img alt="VPN Guides Banner" className="logo-banner" src="https://i.e-z.host/iiuvfmip.png"></img>
        <div className="top-container">
        <div className="titles-container">
        <h3 className="main-heading">
          Why use VPN Guides?
        </h3>
        <p>
        We are 100% honest and upfront about everything we do. Every VPN we rank and list is a VPN that has been tried and tested! We are also fully open to feedback, so feel free 
        to give any feedback you may have, good or bad.
        </p>
      </div>
      </div>
      <h3>Our top PWMs:</h3>
      <table className="top-vpn-table">
        <thead>
          <tr>
            <th>#</th>
            <th>PWM</th>
            <th>Description</th>
            <th>Rating</th>
          </tr>
        </thead>
        <tbody>
          {topPassMans.map((pwm, index) => (
            <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
              <td className="number-cell">{index + 1}</td>
              <td className="vpn-cell">
                <a href={pwm.tUrl} target="_blank" rel="noreferrer">
                  {pwm.tName}
                </a>
              </td>
              <td className="description-cell">{pwm.tDescription}</td>
              <td className="rating-cell">{pwm.tRating}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="updates-container">
        <h3>VPN Guides Updates - 12/2025:</h3>
        <p>Added Antivirus Tier List.</p>
        <p>----------------------------------------------------------------</p>
        <h3>VPN Guides Updates - 10/2025:</h3>
        <p>Website updates: Updated styling, improved table layouts, and enhanced user experience</p>
        <p>----------------------------------------------------------------</p>
        <h3>VPN Guides Updates - 1/2025:</h3>
        <p>Updated tier list order and top VPNs order</p>
        <p>----------------------------------------------------------------</p>
        <h3>VPN Guides Updates - 1/2025:</h3>
        <p>Updated VPN tier list and added a Password Manager tier list!</p>
        <p>----------------------------------------------------------------</p>
        <h3>VPN Guides Updates - 8/2024:</h3>
        <p>Initial release of the VPN Guides rankings!</p>
      </div>
    </div>
  );
};

export default PassList;
